import { Form } from '@/src/components/Antd';
import React from 'react';
import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import css from './css.module.less';
// import { modal } from '@/src/utils/Modal';
// import { replaceI18nVariables } from '@/src/tools/tools';
import { get } from 'lodash';
import { kF, kL } from './index';
const removeOptions = (remove, index) => {
  remove(index);
};
export const genderColumns = (
  remove,
  disabled,
  handleOnEditScript,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelDigitalMarketing.index.scriptName'),
    dataIndex: 'value',
    default: true,
    optional: true,
    key: 'value',
    minWidth: 100,
    childGenerate: (text, record, index) => {
      return (
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues.script !== currentValues.script;
          }}>
          {({ getFieldValue }) => {
            const scriptName = get(
              getFieldValue(`${kF}`),
              `${kL}.${index}.scriptName`,
            );

            return <div>{scriptName}</div>;
          }}
        </Form.Item>
      );
    },
  },
  {
    title: getI18n('salesChannelDigitalMarketing.index.scriptBody'),
    dataIndex: 'value',
    default: true,
    optional: true,
    key: 'value',
    minWidth: 300,
    childGenerate: (text, record, index) => {
      return (
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues.script !== currentValues.script;
          }}>
          {({ getFieldValue }) => {
            const scriptBody = get(
              getFieldValue(`${kF}`),
              `${kL}.${index}.scriptBody`,
            );

            return <div className={css.scriptBodyDisplay}>{scriptBody}</div>;
          }}
        </Form.Item>
      );
    },
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    width: 256,
    childGenerate: (text, record, index) => (
      <div className={css.actionDelete}>
        <Action
          disabled={disabled}
          onDelete={() => removeOptions(remove, index)}
          onEdit={() => {
            handleOnEditScript(index);
          }}
        />
      </div>
    ),
  },
];
